import { render } from "./Gauge.vue?vue&type=template&id=9b1a82dc&scoped=true"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9b1a82dc"

export default script